// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2BHnu","amount":"Amount_amount__3GRD-","tip":"Amount_tip__2v_wX","tipHeader":"Amount_tipHeader__2PzDd","tipsWrap":"Amount_tipsWrap__1HFDX"};